<template>
  <div class="ts-qr-code" :style="wrapperStyle">
    <qrcode-vue
      v-if="value"
      :value="value"
      :size="normalizedSize"
      :level="level"
      :background="background"
      :foreground="foreground"
      render-as="canvas"
      class-name="ts-qr-code-canvas"
    />
    <div v-else class="ts-qr-code-empty" :style="emptyStyle"></div>
    <div v-if="icon && value" class="ts-qr-code-icon" :style="iconWrapperStyle">
      <img :src="icon" alt="" :style="iconImageStyle" @error="onIconError" />
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'TsQrCode',
  components: { QrcodeVue },
  props: {
    value: { type: String, required: true },
    size: { type: Number, default: 220 },
    foreground: { type: String, default: '#0f172a' },
    background: { type: String, default: '#ffffff' },
    icon: { type: String, default: null },
    iconSize: { type: Number, default: 42 },
    level: { type: String, default: 'L' }
  },
  computed: {
    normalizedSize() {
      return Math.max(1, Math.floor(Number(this.size || 220)))
    },
    normalizedIconSize() {
      const maxIconSize = Math.floor(this.normalizedSize * 0.22)
      return Math.max(1, Math.min(Math.floor(Number(this.iconSize || 42)), maxIconSize))
    },
    wrapperStyle() {
      return {
        width: this.normalizedSize + 'px',
        height: this.normalizedSize + 'px',
        backgroundColor: this.background
      }
    },
    emptyStyle() {
      return {
        width: this.normalizedSize + 'px',
        height: this.normalizedSize + 'px',
        backgroundColor: this.background
      }
    },
    iconWrapperStyle() {
      const padding = Math.max(4, Math.ceil(this.normalizedIconSize * 0.18))
      const wrapperSize = this.normalizedIconSize + padding * 2

      return {
        width: wrapperSize + 'px',
        height: wrapperSize + 'px',
        marginLeft: (wrapperSize / -2) + 'px',
        marginTop: (wrapperSize / -2) + 'px',
        padding: padding + 'px',
        backgroundColor: this.background
      }
    },
    iconImageStyle() {
      return {
        width: this.normalizedIconSize + 'px',
        height: this.normalizedIconSize + 'px'
      }
    }
  },
  methods: {
    onIconError(error) {
      this.$emit('error', error)
    }
  }
}
</script>

<style scoped>
.ts-qr-code {
  position: relative;
  display: block;
  overflow: hidden;
  line-height: 0;
}

.ts-qr-code-empty {
  display: block;
}

.ts-qr-code /deep/ .ts-qr-code-canvas,
.ts-qr-code /deep/ canvas {
  display: block;
}

.ts-qr-code-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  pointer-events: none;
}

.ts-qr-code-icon img {
  display: block;
  object-fit: contain;
}
</style>
